var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 451.9 375.6",
    style: {
      enableBackground: "new 0 0 451.9 375.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:15;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:15;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.5,43.5c47-22,94.5-36,143.1-36c52.8,0,110.3,14,160,36c1.8,28.3,4.9,112.9-40.5,197 c-22.6,41.9-72.7,99.5-110.6,99.5 M140.5,43.5c-1.8,28.3-4.9,112.9,40.5,197c22.6,41.9,73.5,99.5,111.4,99.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.3,141.5c0-18,42.5-23.4,61.5-23.4c11,0,27.5,3.9,27.5,23.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404,141.5c0-18-42.5-23.4-61.5-23.4c-11,0-27.5,3.9-27.5,23.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M224.9,223.5c21.5,0.2,45.2,8.3,66.7,8.5c23.4,0.2,44.5-7.7,67.9-7.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M224.9,223.5c2,32,45.2,63.8,66.7,64c23.3,0.2,67.9-32,67.9-63"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M251.2,354.2c-4.3,4.5-8.9,8-13.7,10.2 M7.5,181.9c29.7-34.8,62.8-63.4,101.7-81 M7.5,181.9 c8.8,23.4,37.2,92.4,104.3,143.4c33.4,25.4,95.3,53.1,125.7,39.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.7,226.8c6.6,14.4,27.4,9.2,41.6,2.8c8.2-3.7,22.4-15.1,26.9-25.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasks);
export default __webpack_public_path__ + "static/media/masks.e055a74d45ee498ff71e30715b3f6818.svg";
export { ForwardRef as ReactComponent };